export default "__VITE_ASSET__C5VA4QsN__"